const underConstructionDictPT = {
  comingSoon: 'Em Breve',
  photoBy: 'Foto por',
}

export default underConstructionDictPT;